
export const addPreloadParam=(query) => {
  let preload = 'preload';
  let preloadAttribute = (query.includes('?') ? '&' : '?') + preload + '=true';
  return query.includes(preload) ? query : query + preloadAttribute;
}